import api from "$services/api";
import { persistValue } from "$services/local";
import { Store } from "pullstate";

const initialState = {
    isImpersonating: false,
    impersonatedUserId: null,
    impersonatedUserDisplayName: null,
    impersonationEnabled: false,
};

export const ImpersonateStore = new Store(initialState);

const clearCacheForImpersonate = async () => {
    await persistValue(api.buildCacheKey("/api/users/profile"), null);
};

export const getCurrentSession = async (id) => {
    try {
        const response = await api.get("api/admin/impersonate/session");

        ImpersonateStore.update((s) => {
            return {
                isImpersonating: response.isActive,
                impersonatedUserId: response.impersonatedUserId,
                impersonatedUserDisplayName: response.impersonatedUserDisplayName,
                impersonationEnabled: true,
            };
        });
        return response;
    } catch {
        ImpersonateStore.update((s) => {
            return {
                ...initialState,
            };
        });
    }
};

export const startNewSession = async (userIdToImpersonate) => {
    const response = await api.post(`/api/admin/impersonate/session-start/${userIdToImpersonate}`);
    if (response) {
        await clearCacheForImpersonate();
        getCurrentSession();
    }
};

export const endCurrentSession = async () => {
    const response = await api.post("/api/admin/impersonate/session-end");
    if (response) {
        await clearCacheForImpersonate();
        getCurrentSession();
    }
    return response;
};
